import { render, staticRenderFns } from "./AndamentoLista.vue?vue&type=template&id=a415b438&scoped=true&"
import script from "./AndamentoLista.vue?vue&type=script&lang=js&"
export * from "./AndamentoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a415b438",
  null
  
)

export default component.exports